import React from "react"
import styled from "@emotion/styled"

const CapitariaLogo = styled.svg`
  @media (max-width: 425px) {
    width: 135.75px;
    height: 30px;
  }
`

const CapitariaLogoBlack = () => (
  <CapitariaLogo
    width="181"
    height="40"
    viewBox="0 0 138 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#logoblackcapitaria)">
      <path
        d="M94.5549 0.242432L102.639 18.0329L96.6725 29.9998H88.7755L94.7313 18.0329L86.6688 0.242432H94.5549Z"
        fill="#72C552"
      />
      <path
        d="M1.89701 25.5333H0.242599V24.6841H4.47789V25.5333H2.82348V29.912H1.89701V25.5333Z"
        fill="#363F41"
      />
      <path
        d="M6.19823 24.6841H8.52544C9.1872 24.6841 9.69456 24.8826 10.0365 25.2025C10.3122 25.4892 10.4666 25.8753 10.4666 26.3275V26.3385C10.4666 27.1988 9.94823 27.7172 9.22029 27.9157L10.6321 29.89H9.55117L8.27176 28.0701H7.11367V29.89H6.19823V24.6841ZM8.45926 27.276C9.12103 27.276 9.52911 26.9341 9.52911 26.4047V26.3936C9.52911 25.8311 9.12103 25.5333 8.44823 25.5333H7.11367V27.287H8.45926V27.276Z"
        fill="#363F41"
      />
      <path
        d="M14.1945 24.6506H15.0438L17.349 29.9117H16.3784L15.8489 28.6543H13.3784L12.8379 29.9117H11.9004L14.1945 24.6506ZM15.507 27.8381L14.6026 25.7425L13.7092 27.8381H15.507Z"
        fill="#363F41"
      />
      <path
        d="M18.9926 24.6841H20.9448C22.5882 24.6841 23.7242 25.8091 23.7242 27.287V27.2981C23.7242 28.765 22.5882 29.912 20.9448 29.912H18.9926V24.6841ZM20.9448 29.0738C22.0477 29.0738 22.7647 28.3348 22.7647 27.3091V27.2981C22.7647 26.2723 22.0477 25.5223 20.9448 25.5223H19.9191V29.0738H20.9448Z"
        fill="#363F41"
      />
      <path
        d="M25.5769 24.6841H29.4593V25.5113H26.5034V26.8679H29.1174V27.6841H26.5034V29.0959H29.4924V29.912H25.5769V24.6841Z"
        fill="#363F41"
      />
      <path
        d="M31.3346 24.6846H33.6618C34.3235 24.6846 34.8309 24.8831 35.1728 25.203C35.4485 25.4897 35.603 25.8757 35.603 26.328V26.339C35.603 27.1993 35.0846 27.7177 34.3566 27.9162L35.7684 29.8905H34.6875L33.4081 28.0706H32.261V29.8905H31.3456V24.6846H31.3346ZM33.5956 27.2765C34.2574 27.2765 34.6655 26.9346 34.6655 26.4052V26.3941C34.6655 25.8316 34.2574 25.5338 33.5846 25.5338H32.25V27.2875H33.5956V27.2765Z"
        fill="#363F41"
      />
      <path
        d="M37.125 29.1508L37.6764 28.4891C38.1728 28.9192 38.6801 29.1729 39.3308 29.1729C39.8933 29.1729 40.2573 28.9082 40.2573 28.5111V28.5001C40.2573 28.1251 40.0477 27.9266 39.0772 27.6949C37.9632 27.4302 37.3345 27.0993 37.3345 26.1288V26.1177C37.3345 25.2243 38.0845 24.6067 39.1213 24.6067C39.8823 24.6067 40.4889 24.8383 41.0183 25.2685L40.522 25.9633C40.0477 25.6104 39.5845 25.4229 39.0992 25.4229C38.5588 25.4229 38.25 25.6986 38.25 26.0405V26.0515C38.25 26.4596 38.4926 26.6361 39.4852 26.8677C40.5882 27.1324 41.1617 27.5295 41.1617 28.4008V28.4118C41.1617 29.3935 40.3897 29.978 39.2977 29.978C38.5147 29.9891 37.7536 29.7133 37.125 29.1508Z"
        fill="#363F41"
      />
      <path
        d="M45.7612 27.3087V27.2977C45.7612 25.8308 46.8972 24.5955 48.5075 24.5955C50.1178 24.5955 51.2318 25.8087 51.2318 27.2866V27.2977C51.2318 28.7646 50.0958 29.9999 48.4855 29.9999C46.8862 29.9999 45.7612 28.7866 45.7612 27.3087ZM50.2612 27.3087V27.2977C50.2612 26.283 49.5222 25.4337 48.4855 25.4337C47.4487 25.4337 46.7208 26.2609 46.7208 27.2756V27.2866C46.7208 28.3013 47.4597 29.1506 48.4965 29.1506C49.5443 29.1616 50.2612 28.3344 50.2612 27.3087Z"
        fill="#363F41"
      />
      <path
        d="M53.0959 24.6841H53.9452L56.7466 28.3017V24.6841H57.651V29.912H56.879L54.0003 26.1951V29.912H53.0959V24.6841Z"
        fill="#363F41"
      />
      <path
        d="M59.7356 24.6841H60.6621V29.0738H63.4084V29.912H59.7356V24.6841Z"
        fill="#363F41"
      />
      <path
        d="M65.6801 27.8495L63.5955 24.6841H64.6874L66.1433 27.0003L67.6212 24.6841H68.6801L66.6065 27.8275V29.912H65.6801V27.8495Z"
        fill="#363F41"
      />
      <path
        d="M14.1176 13.7426C13.4449 14.3272 12.75 14.8125 12.0662 15.1765C11.239 15.6176 10.2353 15.8493 9.08824 15.8493C8.18382 15.8493 7.34559 15.6728 6.57353 15.3199C5.8125 14.9669 5.13971 14.4816 4.57721 13.864C4.01471 13.2574 3.58456 12.5294 3.27574 11.7132C2.96691 10.8971 2.8125 10.0257 2.8125 9.11029V9.05515C2.8125 8.13971 2.96691 7.26838 3.27574 6.46323C3.58456 5.65809 4.01471 4.94118 4.57721 4.33456C5.13971 3.72794 5.80147 3.24265 6.57353 2.88971C7.34559 2.53676 8.18382 2.36029 9.08824 2.36029C10.1691 2.36029 11.1397 2.58088 11.989 3.01103C12.6728 3.36397 13.3346 3.80515 13.9743 4.34559L14.1507 4.5L15.8382 2.55882L15.6618 2.40441C15.3529 2.12868 15.0221 1.86397 14.6912 1.62132C14.2279 1.29044 13.7096 0.992647 13.1581 0.761029C12.6066 0.518382 12 0.330882 11.3382 0.198529C10.6654 0.0661765 9.91544 0 9.11029 0C7.76471 0 6.52941 0.242647 5.4375 0.716912C4.33456 1.19118 3.36397 1.85294 2.55882 2.68015C1.75368 3.50735 1.11397 4.47794 0.672794 5.56985C0.220588 6.66176 0 7.85294 0 9.11029V9.16544C0 10.4228 0.231618 11.614 0.683824 12.7169C1.13603 13.8199 1.77574 14.7904 2.56985 15.5956C3.36397 16.4007 4.32353 17.0515 5.40441 17.5147C6.48529 17.9779 7.6875 18.2206 8.97794 18.2206C9.80515 18.2206 10.5662 18.1434 11.239 18C11.9228 17.8566 12.5404 17.6471 13.1029 17.3713C13.6654 17.0956 14.2059 16.7647 14.7022 16.3897C15.0772 16.1029 15.4412 15.7831 15.7831 15.4412L15.9485 15.2757L14.2721 13.5882L14.1176 13.7426Z"
        fill="#363F41"
      />
      <path
        d="M48.4079 1.89679C47.8343 1.38943 47.1395 0.992374 46.3233 0.727668C45.4961 0.451933 44.5586 0.31958 43.5439 0.31958H36.6615V18.0438H39.2645V12.0769H43.1579C44.1284 12.0769 45.0549 11.9446 45.9152 11.6909C46.7645 11.4372 47.5034 11.0512 48.1321 10.5549C48.7608 10.0585 49.2571 9.4409 49.6101 8.72399C49.974 7.99605 50.1505 7.13576 50.1505 6.16517V6.11002C50.1505 5.2387 49.9961 4.43355 49.6983 3.72767C49.4005 3.02179 48.9704 2.40414 48.4079 1.89679ZM39.2755 2.63576H43.2681C44.5255 2.63576 45.5402 2.93355 46.3012 3.51811C47.0843 4.1137 47.4814 5.00708 47.4814 6.1762V6.23134C47.4814 7.26811 47.0954 8.1284 46.3343 8.77914C45.5843 9.42987 44.5586 9.76076 43.2792 9.76076H39.2865V2.63576H39.2755Z"
        fill="#363F41"
      />
      <path
        d="M56.3495 0.309082H53.7355V18.0333H56.3495V0.309082Z"
        fill="#363F41"
      />
      <path
        d="M74.2391 0.309082H60.0663V2.71349H65.8236V18.0333H68.4817V2.71349H74.2391V0.309082Z"
        fill="#363F41"
      />
      <path
        d="M116.239 0.309082H113.636V18.0333H116.239V0.309082Z"
        fill="#363F41"
      />
      <path
        d="M83.3047 0.309082H80.8782L73.5547 18.0333H76.4003L82.0363 4.24658L87.6944 18.0333H90.6172L83.3599 0.463494L83.3047 0.309082Z"
        fill="#363F41"
      />
      <path
        d="M27.1546 0.309082H24.7281L17.4046 18.0333H20.2502L25.8862 4.24658L31.5553 18.0333H34.4671L27.2097 0.463494L27.1546 0.309082Z"
        fill="#363F41"
      />
      <path
        d="M130.059 0.463494L130.004 0.309082H127.566L120.254 18.0333H123.099L128.735 4.24658L134.393 18.0333H137.316L130.059 0.463494Z"
        fill="#363F41"
      />
      <path
        d="M108.628 2.02967C108.077 1.50026 107.371 1.07011 106.533 0.772317C105.695 0.463494 104.702 0.309082 103.599 0.309082H98.2277L99.3086 2.62526H103.312C104.57 2.62526 105.562 2.90099 106.268 3.45246C106.996 4.01496 107.371 4.8532 107.371 5.92305V5.9782C107.371 6.9929 106.996 7.82011 106.246 8.4157C105.662 8.90099 104.89 9.18776 103.985 9.26496L102.805 9.29805H102.364L106.467 18.0333H109.489L106.125 11.0297C106.709 10.8532 107.195 10.5775 107.614 10.3238C108.11 10.026 108.54 9.65099 108.904 9.22085C109.268 8.7907 109.544 8.28335 109.753 7.72085C109.952 7.14732 110.062 6.50761 110.062 5.80173V5.74658C110.062 4.99658 109.941 4.2907 109.698 3.67305C109.445 3.06643 109.092 2.51496 108.628 2.02967Z"
        fill="#363F41"
      />
    </g>
    <defs>
      <clipPath id="logoblackcapitaria">
        <rect width="137.316" height="30" fill="white" />
      </clipPath>
    </defs>
  </CapitariaLogo>
)

export default CapitariaLogoBlack
